<template>
    <v-sheet>
        <vertical-form-table v-model="form" v-bind="{ items }" @input="emit"></vertical-form-table>

        <terms-of-agreements-short v-model="form._terms" @input="emit" @isValid="(value) => $emit('setIsTermsValid', value)" />
    </v-sheet>
</template>

<script>
import { attrs_input, initExpoEmployee } from "@/assets/variables";

import TermsOfAgreementsShort from "@/components/client/join/terms-of-agreements-short.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        key: "info.desc",
        term: "구직회원 소개",
        type: "textarea",
        required: true,

        placeholder: "구직회원 소개를 작성하세요.",
    },
    {
        key: "info.name",
        term: "이름",
        type: "text",
        required: true,

        placeholder: "이름을 입력하세요.",
    },
    {
        key: "info.phone",
        term: "연락처",
        type: "phone",
        required: true,
    },
    {
        key: "info.email",
        term: "이메일",
        type: "email",
        required: true,

        placeholder: "이메일을 입력하세요.",
    },
].map((item) => ({
    ...attrs_input,
    ...item,
}));

export default {
    components: {
        TermsOfAgreementsShort,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initExpoEmployee },
    },
    data: () => ({
        form: initExpoEmployee(),

        items,
    }),
    methods: {
        sync() {
            this.form = initExpoEmployee(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>